/*!
 * Content slider — anulează click-ul care urmează după un drag cu mouse-ul.
 *
 * Slide-urile au un link care acoperă toată imaginea (.full-unstyled-link).
 * ScrollSnapDraggable face preventDefault pe mousedown/mouseup, dar browserul
 * emite oricum `click` la final, deci fără garda asta orice drag ar naviga.
 */
(function () {
  const DRAG_THRESHOLD = 6;
  const SLIDER_SELECTOR = '.slider--showcase[data-draggable="true"]';

  function guardSlider(slider) {
    if (slider.dataset.dragGuard === 'true') return;
    slider.dataset.dragGuard = 'true';

    let startX = null;
    let dragged = false;

    slider.addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;
      startX = event.clientX;
      dragged = false;
    });

    window.addEventListener('mousemove', (event) => {
      if (startX === null) return;
      if (Math.abs(event.clientX - startX) > DRAG_THRESHOLD) dragged = true;
    });

    window.addEventListener('mouseup', () => {
      startX = null;
    }, true);

    slider.addEventListener('click', (event) => {
      if (!dragged) return;
      dragged = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function init(root) {
    (root || document).querySelectorAll(SLIDER_SELECTOR).forEach(guardSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
